import {
    IStatePointResult, IStatePoint,
} from '@src/slide/application/service/slide-render-state/slide-render-state-manager.interface';
import BaseStatePoint from '@src/slide/application/service/slide-render-state/state-point/base-state-point';
import { loadChunks } from '@src/js/stores/load-chunks';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import tdocsBridge from '@src/slide/infrastructure/module/independent/tdocsBridge/tdocsBridge';

export default class FirstSlideRenderStatePoint extends BaseStatePoint implements IStatePoint {
    public emitPointComplete(params: IStatePointResult): boolean {
        const isFirstTime = super.emitPointComplete(params);
        if (isFirstTime) {
            this.completeResolve(params);

            // 某些借用此时机的操作(历史逻辑)
            loadChunks();
            // 某些借用此时机的操作(历史逻辑)
            window.firstScreenBrandLoading?.hide();

            // 提供eventBus方式
            eventBus.emit(EventKeys.FIRST_PAGE_DISPLAY);
            // 提供原生Event方式（应对内嵌html代码）
            window.dispatchEvent(new Event('first-page-display'));
            // 客户端方式（移除mask）
            tdocsBridge.invokeDocx('firstLoadFinished');

            window.log?.info('[tti-notifyFirstSlideRenderCompleted]', params.time, params.entry);
        }
        return isFirstTime;
    }
}
